import { api } from "$lib/api/client";

interface Account { id: string; name: string; type: string; currency: string; color?: string | null; icon?: string | null; }

function createAccounts() {
  let list = $state<Account[]>([]);
  let loading = $state(false);
  let loaded = $state(false);

  async function load(force = false) {
    if (loaded && !force) return;
    loading = true;
    try { list = await api<Account[]>("/accounts"); loaded = true; }
    finally { loading = false; }
  }

  async function ensureDefault(): Promise<Account> {
    await load();
    if (list.length > 0) return list[0]!;
    const created = await api<Account>("/accounts", {
      method: "POST",
      body: JSON.stringify({ name: "Carteira", type: "cash", currency: "BRL", initial_balance: "0" }),
    });
    list = [...list, created];
    return created;
  }

  async function create(payload: Partial<Account> & { name: string }) {
    const created = await api<Account>("/accounts", {
      method: "POST",
      body: JSON.stringify({ type: "checking", currency: "BRL", initial_balance: "0", ...payload }),
    });
    list = [...list, created];
    return created;
  }

  return {
    get list() { return list; },
    get loading() { return loading; },
    load, ensureDefault, create,
  };
}

export const accounts = createAccounts();
